import React from "react";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

type ExportPdfButtonProps = {
  data: any[];
  title: string;
  columns: { header: string; key: string }[];
};

const ExportPdfButton: React.FC<ExportPdfButtonProps> = ({
  data,
  title,
  columns,
}) => {
  const handleExportPdf = () => {
    const currentDate = new Date();
    const timestamp = currentDate.toLocaleString();
    const isWideFormat = columns.length > 8;
    const pageWidth = isWideFormat ? 420 : 297;
    const pageHeight = isWideFormat ? 297 : 210;

    const doc = new jsPDF({
      orientation: "landscape",
      unit: "mm",
      format: isWideFormat ? [pageWidth, pageHeight] : "a4",
    });

    doc.setFontSize(16);
    doc.text(`${title} Report`, 14, 15);
    doc.setFontSize(12);
    doc.text(`Generated on: ${timestamp}`, 14, 23);

    const tableColumnHeaders = columns.map(column => column.header);
    const tableRows = data.map(item =>
      columns.map(column => item[column.key] ?? "No data"),
    );

    const fontSize = isWideFormat ? 8 : 10;
    const headFontSize = isWideFormat ? 7 : 8;
    const cellPadding = isWideFormat ? 2 : 3;

    autoTable(doc, {
      head: [tableColumnHeaders],
      body: tableRows,
      startY: 30,
      styles: {
        fontSize,
        cellPadding,
        overflow: "linebreak",
        halign: "left",
      },
      headStyles: {
        fontSize: headFontSize,
        cellPadding: 2,
        fillColor: [22, 160, 133],
        halign: "center",
        fontStyle: "bold",
      },
      margin: { top: 30, left: 10, right: 10 },
      tableWidth: isWideFormat ? pageWidth - 20 : "auto",
      didDrawPage: pageData => {
        const pageCount = doc.getNumberOfPages();
        doc.setFontSize(8);
        doc.text(
          `Page ${pageData.pageNumber} of ${pageCount}`,
          pageWidth - 30,
          pageHeight - 10,
        );
      },
    });

    doc.save(`${title.toLowerCase().replace(/\s+/g, "_")}_report.pdf`);
  };

  return <button onClick={handleExportPdf}>Export PDF Report</button>;
};

export default ExportPdfButton;
